const saleDismissBtns = [].slice.call(document.getElementsByClassName('sale_dismiss'));
const salesDivs = [].slice.call(document.getElementsByClassName('sale'));

saleDismissBtns.forEach((e) => {
  e.addEventListener('click', () => {
    salesDivs.forEach((sd) => sd.remove());
  });
});
